import React from "react"
import styled, { css } from "styled-components"
import { Flex } from "../../styles/base-styles"
import { IconTag } from "../../images/images"

interface Props {
  style?: object
  label: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
  isActive?: boolean
  withMargin?: boolean
}

export const Tag: React.FC<Props> = ({
  style,
  label,
  onClick,
  isActive,
  withMargin = true,
}) => {
  return (
    <TagBox
      isActive={isActive}
      pointer={Boolean(onClick)}
      style={{ ...style }}
      onClick={onClick || (() => {})}
      withMargin={withMargin}
    >
      <IconTag isActive={isActive || false} />
      <TagLabel isActive={isActive || false}>{label}</TagLabel>
    </TagBox>
  )
}

const TagBox = styled(Flex)<{
  isActive?: boolean
  pointer?: boolean
  withMargin?: boolean
}>`
  background-color: #ededed;
  height: 24px;
  border-radius: 20px;
  padding: 4px 8px;
  font-family: san-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 100% */
  letter-spacing: 1.28px;
  ${props =>
    props.isActive &&
    css`
      color: #fff;
      background: #ef7a00;
    `}

  ${props =>
    props.pointer &&
    css`
      cursor: pointer;
    `}
  ${props =>
    props.withMargin &&
    css`
      margin-right: 8px;
      margin-bottom: 12px;
    `}

  @media screen and (max-width: 767px) {
  }
`

const TagLabel = styled.p<{ isActive?: boolean; pointer?: boolean }>`
  padding: 0 4px;
  color: var(--Black, #000);
  font-feature-settings: "clig" off, "liga" off;
  font-family: san-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 100% */
  letter-spacing: 1.28px;
  ${props =>
    props.isActive &&
    css`
      color: #fff;
      background: #ef7a00;
    `}
`
